var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 352,
    viewBox: "0 0 345 352",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_68",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 345,
    height: 352
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.64674C86.6067 3.21558 143.108 0 169.504 0C196.042 0 216.945 2.50101 232.212 7.50302C247.621 12.3621 261.39 19.1506 273.517 27.8684C297.06 44.5894 314.823 66.8126 326.808 94.5381C338.936 122.264 345 150.346 345 178.786C345 207.226 340.363 232.094 331.089 253.388C321.957 274.539 309.259 292.404 292.993 306.981C259.749 337.136 216.731 352.142 163.939 351.999H0V9.64674ZM133.12 118.333V248.886C140.682 242.455 148.886 236.095 157.733 229.807C191.69 205.368 208.669 179.787 208.669 153.062C208.669 140.056 204.817 128.052 197.112 117.047C189.408 105.9 179.349 100.326 166.935 100.326C154.665 100.326 143.393 106.329 133.12 118.333Z",
    fill: "url(#paint0_linear_18_68)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.64674C86.6067 3.21558 143.108 0 169.504 0C196.042 0 216.945 2.50101 232.212 7.50302C247.621 12.3621 261.39 19.1506 273.517 27.8684C297.06 44.5894 314.823 66.8126 326.808 94.5381C338.936 122.264 345 150.346 345 178.786C345 207.226 340.363 232.094 331.089 253.388C321.957 274.539 309.259 292.404 292.993 306.981C259.749 337.136 216.731 352.142 163.939 351.999H0V9.64674ZM133.12 118.333V248.886C140.682 242.455 148.886 236.095 157.733 229.807C191.69 205.368 208.669 179.787 208.669 153.062C208.669 140.056 204.817 128.052 197.112 117.047C189.408 105.9 179.349 100.326 166.935 100.326C154.665 100.326 143.393 106.329 133.12 118.333Z",
    fill: "url(#paint1_linear_18_68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.506 483.115C-14.5233 483.115 -124 373.652 -124 238.615C-124 223.857 -122.691 209.394 -120.19 195.356C-84.9517 214.915 -31.7942 233.53 31.0016 220.318C36.9591 219.339 43.0227 218.147 49.169 216.696C152.747 192.348 262.507 128.468 356.341 173.909C361.98 194.518 365 216.213 365 238.615C365.012 373.652 255.535 483.115 120.506 483.115Z",
    fill: "#3B8FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.939 350.999H1V10.5753C87.092 4.18931 143.246 1 169.504 1C195.996 1 216.778 3.49869 231.9 8.45338L231.911 8.45673C247.227 13.2865 260.899 20.0294 272.934 28.6804L272.938 28.6837C296.324 45.2938 313.974 67.3692 325.89 94.9349L325.892 94.9389C337.968 122.546 344 150.493 344 178.786C344 207.119 339.38 231.845 330.172 252.989L330.171 252.991C321.093 274.017 308.478 291.761 292.326 306.236L292.321 306.24C259.293 336.199 216.531 351.141 163.942 350.999H163.939ZM132.361 117.683L132.12 117.964V118.333V248.886V251.049L133.768 249.648C141.306 243.237 149.487 236.895 158.312 230.622L158.317 230.619C192.384 206.101 209.669 180.258 209.669 153.062C209.669 139.846 205.751 127.643 197.934 116.478C190.063 105.09 179.711 99.3261 166.935 99.3261C154.293 99.3261 142.765 105.525 132.361 117.683Z",
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_68",
    x1: 172.5,
    y1: 0,
    x2: 172.5,
    y2: 352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_68",
    x1: 0,
    y1: 0,
    x2: 41.5,
    y2: 371.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656845,
    stopColor: "#00F2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.606f61b389941adf1c80422381ec8d4e.svg";
export { ForwardRef as ReactComponent };